/*
 * @Description:
 * @Date: 2024-01-11 14:07:18
 */

import { Directive } from 'vue';

const views = (require as any).context('./', true, /pc-module-cover-\d+\.vue/);

export default views.keys().map(path => {
  return views(path).default;
});

export const posDefaultConfig = {
  'pc-module-cover-1': {
    titlePosition: '{"left":75,"top":284}',
    settleTimePosition: '{"left":75,"top":142}',
    aspNamePosition: '{"left":75,"top":1400}',
    orderNumberPostion: '{"left":75,"top":574}'
  },
  'pc-module-cover-2': {
    titlePosition: '{"left":280,"top":1150,"center":true,"initHeight":205}',
    settleTimePosition: '{"left":490,"top":1468,"center":true}',
    aspNamePosition: '{"left":380,"top":170,"center":true}',
    orderNumberPostion: '{"left":490,"top":1350,"center":true}'
  },
  'pc-module-cover-3': {
    titlePosition: '{"left":100,"top":100}',
    settleTimePosition:
      '{"left":100,"top":92,"topForClassName":"project-name"}',
    aspNamePosition: '{"left":80,"top":1410,"initHeight":45,"left2right":true}',
    orderNumberPostion: '{"left":100,"top":400}'
  },
  'pc-module-cover-4': {
    titlePosition: '{"left":410,"top":600}',
    settleTimePosition:
      '{"left":410,"top":92,"topForClassName":"project-name"}',
    aspNamePosition: '{"left":72,"top":100}',
    orderNumberPostion: '{"left":410,"top":900}'
  },
  'pc-module-cover-5': {
    titlePosition:
      '{"left":280,"top":300,"center":true,"topForClassName":"enterprise-name"}',
    settleTimePosition: '{"left":490,"top":1560,"center":true}',
    aspNamePosition: '{"left":380,"top":82,"center":true}',
    orderNumberPostion: '{"left":280,"top":750,"center":true}'
  },
  'pc-module-cover-6': {
    titlePosition: '{"left":118,"top":800,"initHeight":205,"left2right":true}',
    settleTimePosition:
      '{"left":118,"top":-130,"left2right":true,"topForClassName":"enterprise-name"}',
    aspNamePosition:
      '{"left":118,"top":1550,"initHeight":50,"left2right":true}',
    orderNumberPostion: '{"left":503,"top":1010}'
  },
  'pc-module-cover-7': {
    titlePosition: '{"left":118,"top":100,"left2right":true}',
    settleTimePosition:
      '{"left":118,"top":98,"left2right":true,"topForClassName":"project-name"}',
    aspNamePosition:
      '{"left":118,"top":1400,"initHeight":50,"left2right":true}',
    orderNumberPostion: '{"left":118,"top":400,"left2right":true}'
  },
  'pc-module-cover-8': {
    titlePosition: '{"left":280,"top":720,"initHeight":205,"center":true}',
    settleTimePosition:
      '{"left":490,"top":32,"center":true,"topForClassName":"enterprise-name"}',
    aspNamePosition: '{"left":380,"top":1380,"center":true,"initHeight":50}',
    orderNumberPostion: '{"left":280,"top":800,"initHeight":205,"center":true}'
  },
  'pc-module-cover-9': {
    titlePosition:
      '{"left":118,"top":750,"initHeight":205,"left2right":true,"ycenter":true}',
    settleTimePosition:
      '{"left":118,"top":32,"left2right":true,"topForClassName":"enterprise-name"}',
    aspNamePosition:
      '{"left":118,"top":1400,"initHeight":50,"left2right":true}',
    orderNumberPostion: '{"left":118,"top":790,"initHeight":205,"center":true}'
  },
  'pc-module-cover-10': {
    titlePosition: '{"left":75,"top":140}',
    settleTimePosition:
      '{"left":75,"top":100,"topForClassName":"project-name"}',
    aspNamePosition: '{"left":75,"top":1400}',
    orderNumberPostion: '{"left":75,"top":440}'
  }
};

export const useCover = emits => {
  const info = [
    {
      className: 'enterprise-name',
      valueKey: 'mainPageEnterpriseName',
      posKey: 'aspNamePosition'
    },
    {
      className: 'project-name',
      valueKey: 'projectName',
      posKey: 'titlePosition'
    },
    { className: 'time', valueKey: 'time', posKey: 'settleTimePosition' },
    {
      className: 'order-number',
      valueKey: 'orderNumber',
      posKey: 'orderNumberPostion'
    }
  ];

  const onPosChange = (posKey: string, left: number, top: number) => {
    emits('posChange', { posKey, left, top });
  };

  const onValueChange = (valueKey: string, value: string) => {
    emits('valueChange', { valueKey, value });
  };
  return { onPosChange, onValueChange, info };
};

const checkIsEdit = (dom: HTMLDivElement) => {
  return dom.getAttribute('data-edit') === 'true';
};

export const vInput: Directive = {
  mounted(
    dom: HTMLDivElement,
    bindInfo: {
      value: {
        change: (value: string) => void;
        value: string;
      };
    }
  ) {
    if (!checkIsEdit(dom)) return;
    dom.setAttribute('contenteditable', 'true');
    dom.style.border = '2px dashed #A7A7A7';
    dom.onblur = () => {
      bindInfo.value.change(dom.innerHTML);
    };
  },
  beforeUnmount(dom: HTMLDivElement) {
    dom.onblur = null;
  }
};

export const vMove: Directive = {
  mounted(
    dom: HTMLDivElement,
    bindInfo: {
      value: {
        change: (left: number, top: number) => void;
        pos: {
          left: number;
          top: number;
          ycenter?: boolean;
          center?: boolean;
          initHeight?: number;
          left2right?: boolean;
          topForClassName?: string;
          otherTop?: number;
        };
      };
    }
  ) {
    const parentWidth = dom.parentElement.offsetWidth;
    const selfWidth = dom.offsetWidth;
    const parentHeight = dom.parentElement.offsetHeight;
    const selfHeight = dom.offsetHeight;
    const { pos, change } = bindInfo.value;
    const setPos = (left: number, top: number) => {
      dom.style.left = `${Math.max(0, left)}px`;
      dom.style.top = `${Math.max(0, top)}px`;
    };
    let _left = pos?.left;
    let _top = pos?.top;
    if (pos?.center) {
      _left = (parentWidth - selfWidth) / 2;
    }
    if (pos?.initHeight) {
      _top -= selfHeight - pos?.initHeight;
    }
    if (pos?.left2right) {
      _left = parentWidth - selfWidth - pos?.left;
    }
    if (pos?.ycenter) {
      _top = (parentHeight - selfHeight) / 2;
    }
    if (pos?.topForClassName) {
      const targetDom = dom.parentElement.querySelector(
        `.${pos?.topForClassName}`
      ) as HTMLDivElement;
      if (targetDom) {
        _top = pos?.top + targetDom.offsetHeight + targetDom.offsetTop;
      }
    }

    setPos(_left, _top);
    if (!checkIsEdit(dom)) return;
    dom.onmousedown = e => {
      const parentWidth = dom.parentElement.offsetWidth;
      const selfWidth = dom.offsetWidth;
      const parentHeight = dom.parentElement.offsetHeight;
      const selfHeight = dom.offsetHeight;
      //算出鼠标相对元素的位置
      const disX = e.clientX - dom.offsetLeft;
      const disY = e.clientY - dom.offsetTop;
      let left = 0;
      let top = 0;
      document.onmousemove = e => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        left = Math.max(0, Math.min(e.clientX - disX, parentWidth - selfWidth));
        top = Math.max(
          0,
          Math.min(e.clientY - disY, parentHeight - selfHeight)
        );
        //绑定元素位置到positionX和positionY上面
        //移动当前元素
        setPos(left, top);
      };
      document.onmouseup = () => {
        change(parseInt(dom.style.left), parseInt(dom.style.top));
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
};
